const e = 992, t = 768;
export {
  e as l,
  t as m
};
//# sourceMappingURL=mobile-BpUO1OTk.mjs.map
